var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6154 0C18.3147 0 19.6923 1.37759 19.6923 3.07692V12.9231C19.6923 14.6224 18.3147 16 16.6154 16H3.07692C1.37759 16 0 14.6224 0 12.9231V3.07692C0 1.37759 1.37759 0 3.07692 0H16.6154ZM18.4615 4.87508L10.1582 9.76119C9.99768 9.85559 9.80506 9.87133 9.63386 9.80839L9.53414 9.76119L1.23077 4.87754V12.9231C1.23077 13.9427 2.05732 14.7692 3.07692 14.7692H16.6154C17.635 14.7692 18.4615 13.9427 18.4615 12.9231V4.87508ZM16.6154 1.23077H3.07692C2.05732 1.23077 1.23077 2.05732 1.23077 3.07692V3.44862L9.84615 8.51681L18.4615 3.44738V3.07692C18.4615 2.05732 17.635 1.23077 16.6154 1.23077Z",
    fill: "#E84E1B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.24fd010e5dc6b5fd1d06aa0617327a42.svg";
export { ForwardRef as ReactComponent };